import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import PageFadeIn from "../components/shared/PageFadeIn";
import { data } from "../utils/data.jsx";

const Destination = () => {
	const destinations = data.destinations;
	const [selected, setSelected] = useState(0);

	return (
		<PageFadeIn>
			<div className='absolute top-0 left-0 w-full h-full pt-[88px] md:pt-[136px] xl:pt-[212px] px-6 md:px-[40px] xl:px-[165px] bg-destination_mobile md:bg-destination_tablet xl:bg-destination_desktop bg-cover xl:flex xl:justify-between'>
				<div className='flex flex-col xl:w-[575px]'>
					<div className='flex items-center justify-center md:justify-start gap-[18px]'>
						<p className='font-barlow font-bold md:text-20 xl:text-[28px] leading-19 md:leading-[24px] xl:leading-[34px] tracking-27 md:tracking-[3.37px] xl:tracking-[4.725px] text-white opacity-25'>
							01
						</p>
						<p className='font-barlow md:text-20 xl:text-[28px] leading-19 md:leading-[24px] xl:leading-[34px] tracking-27 md:tracking-[3.37px] xl:tracking-[4.725px] text-white uppercase'>
							Pick your destination
						</p>
					</div>

					<AnimatePresence exitBeforeEnter>
						<motion.div
							className={`w-170 h-170 md:w-300 md:h-300 xl:w-445 xl:h-445 mt-8 mb-7 md:mt-14 md:mb-[53px] mx-auto ${destinations[selected].background} bg-cover`}
							key={selected}
							animate={{ opacity: 1 }}
							initial={{ opacity: 0 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 0.4 }}
						/>
					</AnimatePresence>
				</div>

				<div className='xl:w-[445px] xl:mt-[98px] xl:flex xl:flex-col xl:items-start'>
					{/* planet selector */}
					<div className='w-60 h-7 md:h-8 mx-auto xl:ml-0 flex justify-between'>
						{destinations.map((destination, index) => (
							<div
								key={destination.name}
								className='h-full flex flex-col items-center justify-between cursor-pointer'
								onClick={() => setSelected(index)}
							>
								<p
									className={`font-barlow text-[14px] md:text-16 leading-[17px] md:leading-19 tracking-[2.36px] ${
										selected === index ? "text-white" : "text-lavender"
									} uppercase`}
								>
									{destination.name}
								</p>
								{selected === index && (
									<motion.div className='w-9 h-[3px] bg-white' layoutId='selected_destination' />
								)}
							</div>
						))}
					</div>

					<AnimatePresence exitBeforeEnter>
						<motion.div
							className='mt-5 md:mt-8 md:mx-14 xl:ml-0 flex flex-col xl:items-start'
							key={selected}
							animate={{ opacity: 1 }}
							initial={{ opacity: 0 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 0.4 }}
						>
							<p className='md:mb-4 font-bellefair text-56 md:text-80 leading-64 md:leading-92 text-white uppercase text-center'>
								{destinations[selected].name}
							</p>
							<p className='font-barlow text-[15px] md:text-16 leading-[25px] md:leading-[28px] tracking-[1.5px] text-center xl:text-left text-lavender'>
								{destinations[selected].description}
							</p>
							<div className='w-full h-px my-8 md:mt-[50px] bg-border_grey opacity-50' />

							<div className='flex flex-col md:flex-row md:w-full md:justify-center md:gap-[100px]'>
								<div>
									<p className='font-barlow text-[14px] leading-[17px] tracking-[2.36px] uppercase text-center xl:text-left text-lavender'>
										Avg. Distance
									</p>
									<h3 className='xl:w-[160px] mt-3 mb-8 font-bellefair text-[28px] leading-[32px] text-center xl:text-left text-white uppercase'>
										{destinations[selected].distance}
									</h3>
								</div>
								<div>
									<p className='font-barlow text-[14px] leading-[17px] tracking-[2.36px] uppercase text-center xl:text-left text-lavender'>
										Est. Travel Time
									</p>
									<h3 className='xl:w-[160px] mt-3 mb-8 font-bellefair text-[28px] leading-[32px] text-center xl:text-left text-white uppercase'>
										{destinations[selected].travel}
									</h3>
								</div>
							</div>
						</motion.div>
					</AnimatePresence>
				</div>
			</div>
		</PageFadeIn>
	);
};

export default Destination;
